import React, { useState, useEffect } from 'react';
import { knowledgeBasePageData } from '../data/pageData';
import PageTitle from '../components/PageTitle';
import { FaFacebookF, FaTwitter, FaLinkedinIn } from 'react-icons/fa';
import YouTube from 'react-youtube';

const KnowledgeBasePage = () => {
    const data = knowledgeBasePageData;
    
    // Function to extract YouTube video ID from URL
    const getYouTubeId = (url) => {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    };

    const videoId = getYouTubeId(data.mainArticle.videoSrc);

    const opts = {
        height: '500',
        width: '100%',
        playerVars: {
            autoplay: 0,
            modestbranding: 1,
            rel: 0
        },
    };

    return (
        <div className="bg-white text-gray-800">
            <PageTitle title={data.pageTitle} breadcrumbs={data.breadcrumbs} />
             <section className="py-16 md:py-24">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col lg:flex-row gap-10">
                        <div className="lg:w-2/3 space-y-10">
                            <div className="bg-gray-50 p-6 md:p-8 rounded-xl shadow-2xl transform hover:scale-[1.01] transition-transform duration-300 border border-gray-200">
                                <h2 className="text-2xl md:text-3xl font-bold text-yellow-600 mb-5">{data.mainArticle.title}</h2>
                                <div className="aspect-w-16 aspect-h-9 mb-5 bg-gray-200 rounded-lg overflow-hidden shadow-lg">
                                    {videoId ? (
                                        <YouTube videoId={videoId} opts={opts} className="w-full h-full" />
                                    ) : (
                                        <div className="w-full h-full flex items-center justify-center text-gray-500">
                                            Invalid YouTube URL
                                        </div>
                                    )}
                                </div>
                                <ul className="list-disc list-inside text-gray-700 space-y-1.5 text-sm mb-6 pl-2">
                                    {data.mainArticle.topics.map(topic => <li key={topic}>{topic}</li>)}
                                </ul>
                                <button 
                                    onClick={() => window.open(data.mainArticle.pdfUrl, '_blank')}
                                    className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-8 py-3 rounded-md text-sm shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                                >
                                    {data.mainArticle.buttonText}
                                </button>
                            </div>

                            {data.articles.map((article, index) => (
                                <div key={index} className="bg-gray-50 p-6 md:p-8 rounded-xl shadow-2xl transform hover:scale-[1.01] transition-transform duration-300 border border-gray-200">
                                    <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-4">{article.title}</h3>
                                    {article.video && article.topics && (
                                        <div className="mb-5">
                                            <div className="aspect-w-16 aspect-h-9 mb-4 bg-gray-200 rounded-lg overflow-hidden shadow-lg">
                                                {getYouTubeId(article.videoSrc) ? (
                                                    <YouTube 
                                                        videoId={getYouTubeId(article.videoSrc)} 
                                                        opts={{
                                                            height: '500',
                                                            width: '100%',
                                                            playerVars: {
                                                                autoplay: 0,
                                                                modestbranding: 1,
                                                                rel: 0
                                                            },
                                                        }} 
                                                        className="w-full h-full" 
                                                    />
                                                ) : (
                                                    <div className="w-full h-full flex items-center justify-center text-gray-500">
                                                        Invalid YouTube URL
                                                    </div>
                                                )}
                                            </div>
                                            <ul className="list-disc list-inside text-gray-700 space-y-1 text-xs pl-2">
                                                {article.topics.map(topic => <li key={topic}>{topic}</li>)}
                                            </ul>
                                        </div>
                                    )}
                                    {!article.video && article.summary && <p className="text-gray-700 text-sm mb-5 leading-relaxed">{article.summary}</p>}
                                    <button 
                                        onClick={() => window.open(article.pdfUrl, '_blank')}
                                        className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-8 py-3 rounded-md text-sm shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                                    >
                                        {article.buttonText}
                                    </button>
                                </div>
                            ))}
                        </div>
                        <aside className="lg:w-1/3 space-y-10 sticky top-24 self-start">
                             <div className="bg-gray-100 p-8 rounded-xl shadow-2xl border border-gray-200">
                                <h3 className="text-2xl font-bold text-gray-900 mb-4">{data.sidebar.questionsTitle}</h3>
                                <p className="text-gray-700 text-sm mb-6 leading-relaxed">{data.sidebar.questionsText}</p>
                                <button onClick={() => { const el = document.getElementById('contact'); if (el) el.scrollIntoView({behavior: 'smooth'});}} className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-6 py-3 rounded-md text-sm shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">{data.sidebar.questionsButtonText}</button>
                            </div>
                            <div className="bg-gray-100 p-8 rounded-xl shadow-2xl border border-gray-200">
                                <h3 className="text-2xl font-bold text-gray-900 mb-5">{data.sidebar.followTitle}</h3>
                                <div className="flex justify-start space-x-3 mt-5">
                                        <a 
                                            href="#" 
                                            className="w-8 h-8 flex items-center justify-center border border-gray-500 text-gray-400 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 transition-colors duration-300"
                                        >
                                            <FaFacebookF />
                                        </a>
                                        <a 
                                            href="#" 
                                            className="w-8 h-8 flex items-center justify-center border border-gray-500 text-gray-400 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 transition-colors duration-300"
                                        >
                                            <FaTwitter />
                                        </a>
                                        <a 
                                            href="#" 
                                            className="w-8 h-8 flex items-center justify-center border border-gray-500 text-gray-400 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 transition-colors duration-300"
                                        >
                                            <FaLinkedinIn />
                                        </a>
                                    </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default KnowledgeBasePage;